import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NiceWrapper from 'components/NiceWrapper';
import { Flex, Box, Heading, Button } from 'rebass';
import { Label, Switch, Input } from '@rebass/forms';
import helpers from 'utils/helpers';
import services from 'services/services';
import service_people from 'services/people';
import service_accounts from 'services/accounts';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import LoadingIndicator from 'components/LoadingIndicator';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { FiCheckCircle } from 'react-icons/fi';

function SetNewPassword(props) {
    const history = useHistory();
    const [account, setAccount] = useState({});
    const [resetType, setResetType] = useState(false);
    const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);
    const { addToast } = useToasts();
    
    function useResetPasswordTokenXHR() {
        const password = document.getElementById('password').value;
        const password_confirmation = document.getElementById('password_confirmation').value;

        service_people
            .useResetPasswordToken(props.match.params.token, password, password_confirmation)
            .then(response => {
                setPasswordResetSuccess(true);
                if (response.type == 'User') {
                    setResetType('User');
                } else {
                    setResetType('Person');
                    setAccount(response.account);
                }
            })
            .catch(e => {
                console.log('ERROR', e);
                

                const errorText = services.parseXhrErrors(e);
                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    return (
        <div style={{ margin: 'auto' }}>
            
            <Box style={{ textAlign: 'center'}} mt={4} mb={3}>
                <Heading fontSize={[3, 4]} mt={4}>Reset password</Heading>
            </Box>
            <NiceWrapper style={{ background: 'white', color: 'black', padding: '0', margin: '0 32px' }}>
                <Box pt={4} px={4} pb={3} sx={{textAlign: 'center'}}>
                    <Box fontSize={1} style={{minWidth: '320px'}}>
                        {passwordResetSuccess == false ? 
                            <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); useResetPasswordTokenXHR(); }}>
                                Type in your new password, 8 characters minimum.
                                <Input type='password' mt={3} placeholder='Password' id="password" required autoFocus />
                                <Input type='password' mt={3} placeholder='Confirm Password' id="password_confirmation" required />
                                <Box mt={3}>
                                    <Button type='submit' variant='primary' mr={0} mb={3} style={{width: '100%'}}>Save new password</Button>
                                </Box>
                            </form>
                            :
                            <Box my={4} mx={3}>
                                <FiCheckCircle style={{color: 'green', fontSize:'24px'}}/> <br/><br/>
                                You have successfully reset your password.<br/><br/>

                                {resetType == 'Person' && account ? 
                                    <Link to={`/panelist/${account.uuid}/login`}>
                                        <Button type='button' variant='primary' mr={0}>Continue to Sign In</Button>
                                    </Link>
                                    :
                                    <Link to={`/login`}>
                                        <Button type='button' variant='primary' mr={0}>Continue to Sign In</Button>
                                    </Link>
                                }
                                <br/><br/>
                            </Box>
                        }
                    </Box>
                </Box>
            </NiceWrapper>
        
        </div>
    );
}

export default SetNewPassword;
